import { axiosInstance } from "./https.util"

const fetcher = async (url: string) => await axiosInstance.get(url).then((res) => res.data)

export default fetcher